const PENDING = 'Pending';
const REJECTED = 'Rejected';
const ACTIVE = 'Active';
const INACTIVE = 'Inactive';

export const FulfillmentProviderStatusEnum = {
  PENDING,
  REJECTED,
  ACTIVE,
  INACTIVE,
};
